import { apiBase } from '../apiBase';
import type { BE } from './type';

const api = apiBase.injectEndpoints({
  endpoints: (builder) => ({
    getUserProfileV2: builder.query<BE.GetUserProfileV2.Response, BE.GetUserProfileV2.Request | void>({
      query: (params) => ({
        method: 'get',
        url: '/user-profile/v2/details',
        params: params || {},
        service: 'merchant',
      }),
    }),
    getStoreList: builder.query<BE.GetStoreList.Response, BE.GetStoreList.Request | void>({
      query: () => ({
        method: 'get',
        url: '/v1/chope/group-stores',
        service: 'crm',
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetUserProfileV2Query,
  useLazyGetUserProfileV2Query,
  useGetStoreListQuery,
} = api;
